module.exports = __webpack_public_path__ + "img/ma.svg";